import { render } from "./StafetAddDeltager.vue?vue&type=template&id=59817d56"
import script from "./StafetAddDeltager.vue?vue&type=script&lang=js"
export * from "./StafetAddDeltager.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__